import { render } from "./layoutHeader.vue?vue&type=template&id=851f6fa4&scoped=true"
import script from "./layoutHeader.vue?vue&type=script&lang=js"
export * from "./layoutHeader.vue?vue&type=script&lang=js"

import "./layoutHeader.vue?vue&type=style&index=0&id=851f6fa4&lang=less&scoped=true"
import "./layoutHeader.vue?vue&type=style&index=1&id=851f6fa4&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851f6fa4"]])

export default __exports__